// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qR-Rt","gamer":"styles_gamer__1obwg"};